<template>
  <Query
    :query="$options.shippingLocationsGQL"
    :variables="{ hash }"
    @update:data="setLocations"
  >
    <template #loading>
      <ShimmerCartSectionButton />
    </template>
    <template
      #default="{
        data: {
          shippingLocations: { data },
        },
      }"
    >
      <StoreCartSection v-if="data && data.length > 0" title="">
        <!-- Card -->
        <StoreCartSectionButton
          icon="TeenyiconsPinOutline"
          :label="shippingLocationName || $t('select')"
          :desc="$t('deliver_to')"
          @click="$nuxt.callHook('modal-open', 'shipping-location')"
        />

        <!-- Modal -->
        <Modal id="shipping-location" v-slot="{ close }" @close="search = null">
          <ModalShell :title="$t('deliver_to')" :close="close">
            <div class="p-4">
              <FormField class="mb-4" v-if="data.length > 5">
                <FormTextbox
                  v-model="search"
                  :placeholder="$t('search')"
                  name="search"
                />
              </FormField>
              <div class="space-y-2" v-if="locationOptions.length">
                <StoreShippingLocation
                  v-for="location in locationOptions"
                  :id="location.id"
                  :key="`location-${location.id}`"
                  :name="location.name"
                  :note="location.chargeNote"
                  :selected-id="shippingLocationId"
                  @select="set(location), close()"
                />
              </div>
              <p v-else>{{ $t("no_result_title") }}</p>
            </div>
          </ModalShell>
        </Modal>
      </StoreCartSection>
    </template>
  </Query>
</template>

<script>
import shippingLocationsGQL from "@/graph/store/shipping-locations.gql";
import { useVepaarStore } from "@/store/store.js";
import { useCartStore } from "@/store/cart.js";
import { mapState, mapActions } from "pinia";

export default {
  shippingLocationsGQL,
  props: {
    total: { type: Number, default: null },
  },
  data() {
    return {
      locations: [],
      search: null,
    };
  },
  computed: {
    locationOptions() {
      return this.search
        ? this.locations.filter((location) =>
            location.name.toLowerCase().includes(this.search.toLowerCase())
          )
        : this.locations;
    },
    ...mapState(useVepaarStore, ["hash"]),
    ...mapState(useCartStore, ["shippingLocationId", "shippingLocationName"]),
  },
  methods: {
    ...mapActions(useCartStore, ["upsertCart"]),
    setLocations({ shippingLocations: { data } }) {
      this.locations = data;
    },

    // set(location) {
    //   if (location) {
    //     this.setShippingLocation({ hash: this.hash, id: location?.id })
    //     this.selected = location
    //   } else {
    //     this.setShippingLocation({ hash: this.hash, id: null })
    //     this.selected = null
    //   }
    // },

    set(location) {
      this.upsertCart({ shippingLocationId: location.id });
    },
  },
};
</script>

<style></style>
